<template>
  <div>
    <v-header></v-header>

    <div  class="container" style="padding-top: 60px;">
      <div  class="banner">
        <img  src="../../static/img/banner-6.png" alt="" />
        <h2 class="item-title">
          <span class="eg" style="color:rgba(255,255,255,1)">
            覆盖教育多种招生缴费场景<br> 快速招生，零费率缴费
             <!-- 覆盖教育多种招生缴费场景，优质 <br> 生源一键获取，零费率缴费， <br>效率提升100% -->
             </span>
        </h2>
      </div>
     


      <div   class="onefeatures">
        <!-- <h2   class="item-title"><span   class="eg">选择凡高，一站式助您解决校园管理问题</span> </h2> -->
        <div   class="item-pro" style="margin-top:0px">
          <dl  >
            <dt  >
              <span>学生信息多而乱，老师工作杂而繁</span>
            </dt>
            <dd >
              <img src="../../static/img/com-one.png" alt="">
              <span>凡高教育让学生信息更明晰，线上一键审核，招生效率更高</span>
            </dd>
          </dl>

          <dl  >
            <dt  >
              <span>信息不完善，费劲收集的信息又容易丢失</span>
            </dt>
            <dd >
              <img src="../../static/img/com-two.png" alt="">
              <span>垂直场景全覆盖，让您得到您想要的信息，信息储存云端随时查看，永不丢失</span>
            </dd>
          </dl>

        </div>
        <div class="item-pro">
          
          <dl  >
            <dt  >
              <span>系统信息成千上万，联系起来费时费力</span>
            </dt>
            <dd >
              <img src="../../static/img/com-three.png" alt="">
              <span>凡高教育，审核通知消息一键推送，方便快捷</span>
            </dd>
          </dl>

          <dl  >
            <dt  >
              <span>成本太高用啥都要花钱，关键用的还不舒服</span>
            </dt>
            <dd >
              <img src="../../static/img/com-four.png" alt="">
              <span>缴费零费率，凡高教育让您无后顾之忧</span>
            </dd>
          </dl>
        </div>
      </div>


      <div   class="twofeatures">
        <h2   class="item-title"><span   class="eg">为什么选择凡高教育收费</span> </h2>
        <div   class="item-pro" style="margin-top:40px">
          <dl  >
            <dt  >
             <img src="../../static/img/com-five.png" alt="">
              <p class="span1">更低费率</p>
              <p class="span2"></p>
              <p class="span3">学校使用零费率</p>
            </dt>
           
          </dl>

          <dl  >
            <dt  >
             <img src="../../static/img/com-six.png" alt="">
              <p class="span1">更方便</p>
              <p class="span2"></p>
              <p class="span3">一键扫码缴费，方便快捷</p>
            </dt>
          </dl>

        </div>
        <div class="item-pro">
          
          <dl  >
            <dt  >
             <img src="../../static/img/com-seven.png" alt="">
              <p class="span1">更安全</p>
              <p class="span2"></p>
              <p class="span3">钱款直接对接您的账户，资金安全有保障</p>
            </dt>
          </dl>

          <dl  >
           <dt  >
             <img src="../../static/img/com-eight.png" alt="">
              <p class="span1">更完善</p>
              <p class="span2"></p>
              <p class="span3">缴费项目自定义编辑，财务对账明了清晰，功能强大完善</p>
            </dt>
          </dl>
        </div>
      </div>

      <div class="class-attendance">
        <h2 class="item-title">
         
          <p class="eg">
             <img src="../../static/img/ju-left.png" alt="" class="leftphoto">
            产品优势
             <img src="../../static/img/ju-right.png" alt="" class="leftphoto">
            </p> 
          <!-- <span class="ch">班级考勤功能模块</span> -->
         
        </h2>
        <div class="item-pro">
          <div class="hong">
           
            <span class="hongspan">01  垂直场景全覆盖，专属解决痛点</span>
          </div>
          
          <dl >
            <dt >
              <img src="../../static/img/comtop-one.png">
            </dt>
            <dd >
                <p class="title">招生场景面面覆盖</p>
               <p class="note">小升初、初升高、自主招生、特招生等场景业务自主灵活搭建满足您各场景招生</p>
            </dd>
          </dl>
        
          <dl >
            
            <dt >
              <img src="../../static/img/comtop-two.png">
            </dt>
            <dd >
               <p class="title" >缴费业务样样满足</p>
               <p class="note">学费、杂费、生活费各项缴费业务，更安全、更快捷、更方便</p>
            </dd>
          </dl>
           <div class="huang">
           
            <span class="hongspan">02  报名缴费在线操作，一键审核通知</span>
          </div>
          <dl >
            <dt >
              <img src="../../static/img/comtop-three.png">
            </dt>
            <dd >
              <p class="title" >移动端操作更方便</p>
               <p class="note">移动端报名缴费，业务随时随地处理</p>
            </dd>
          </dl>
            <dl >
            <dt >
              <img src="../../static/img/comtop-four.png">
            </dt>
            <dd >
                <p class="title">一键操作，方便快捷</p>
               <p class="note">名单一键导出，审核结果一键通知，账单信息一键下发</p>
            </dd>
          </dl>
        
           <div class="lv">
           
            <span class="hongspan">03  数据更清晰，财务更准确，资金更安全</span>
          </div>
          <dl >
            
            <dt >
              <img src="../../static/img/comtop-five.png">
            </dt>
            <dd >
               <p class="title" >数据记录查询更清晰</p>
               <p class="note">专属云端数据记录，清晰准确无丢失，学生信息永保存财务对账更放心</p>
            </dd>
          </dl>
          <dl >
            <dt >
              <img src="../../static/img/comtop-six.png">
            </dt>
            <dd >
              <p class="title" >资金账户更安全</p>
               <p class="note">钱款直接对接您的账户，资金安全有保障</p>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hong{
    background-image: url('~@/../static/img/bg-hong.png');
    background-size: 100% 100%;
    width:94%;
  height:114px;
  margin: 0 auto;
  margin-top: 80px;
}
.huang{
    background-image: url('~@/../static/img/bg-huang.png');
    background-size: 100% 100%;
    width:94%;
  height:114px;
  margin: 0 auto;
  margin-top: 80px;
}
.lv{
    background-image: url('~@/../static/img/bg-lv.png');
    background-size: 100% 100%;
    width:94%;
  height:114px;
  margin: 0 auto;
  margin-top: 80px;
}
.hongspan{
  width:94%;
  font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(255,255,255,1);
display: inline-block;
height:114px;
line-height: 114px;
text-align: center;
margin: 0 auto;
}
  .header {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }
 .leftphoto{
  width: 24px;
  height: 24px;
  margin: 5px 13px;
  display: inline-block;
}
  .main {
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix[data-v-1b7fc878]:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }
 .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .item-title .eg{
   font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);

line-height:21px;
  }

  .product-introduction {
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button {
    background: transparent;
    border: 1px solid #ff9a00;
    color: #ff9a00
  }

  .banner {
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img {
    width: 100%
  }



  .banner .item-title{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
    color:rgba(255,255,255,1);
  }
  .banner .item-title .ch{
  width:488px;
height:50px;
font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
/* margin-top: 30px; */
  }
  .banner .item-title .eg{
   width:609px;
font-size:40px;
font-family:PingFang SC;
font-weight:400;
margin-top: 60px;
line-height:60px;
/* color:rgba(255,255,255,0.3); */
  }
.class-attendance{
    padding: 100px 0;
    /* background: #f9f9f9 */
  }

  .class-attendance .item-pro{
    /* padding: 0 10%; */
    width: 97%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-top: 20px;
    margin: 0 auto;
  }

  .class-attendance .item-pro dl{
   
    flex: 1;
    margin-top: 60px;
    display: flex;
    flex-direction: column;
  }

  .class-attendance .item-pro dt{
    /* width: 100%; */
    display: -ms-flexbox;
    
    -ms-flex-pack: center;
    justify-content: center
  }

  .class-attendance .item-pro dt img{
    width: 320px;
    height: 210px;
    text-align: center;
    margin: 0 auto;
  }

  .class-attendance .item-pro dd{
   
    text-align: center;
    margin: 0 auto;
  }

  .class-attendance .item-pro dd .title{
    font-size:30px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(0,0,0,1);
    line-height:27px;
    margin-top: 30px;
  }

  .class-attendance .item-pro dd .note{
    width:320px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:36px;
    margin-top: 30px;
  }


   .onefeatures {
    /* background: #f9f9f9; */
    padding: 100px 0
  }
.onefeatures .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

.onefeatures  .item-title .eg{
    width:441px;
   font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);

  }
  .onefeatures .item-pro {
    padding: 0;
    width: 95%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin: 0px auto;
  }

  .onefeatures .item-pro dl {
    flex: 1;
    margin: 20px 15px;
   
   height:450px;
    background:rgba(255,255,255,1);
    border-radius:10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  }

  .onefeatures .item-pro dt {
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;

    height:140px;
background:linear-gradient(-45deg,rgba(42,177,243,1),rgba(42,212,243,1));
border-radius:10px 10px 0px 0px;
  }
.onefeatures .item-pro dt span{
  
  margin: auto;
  width: 78%;
  text-align: center;

  font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:36px;
}
  .onefeatures .item-pro dd img {
    width: 80px;
    height: 80px;
    text-align: center;
    margin: 30px auto;
  }

  .onefeatures .item-pro dd {
    width: 100%;
    text-align: center;
    margin: 15px 0 0
  }

  .onefeatures .item-pro dd span {
   width:79%;
height:131px;
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(14,5,10,1);
line-height:36px;
display: inline-block;
  }


.twofeatures {
    /* background: #f9f9f9; */
    padding: 100px 0;
    background-image: url('~@/../static/img/com-bg.png');
    background-size: 100% 100%;
    /* height:894px; */
  }
.twofeatures .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

.twofeatures  .item-title .eg{
    width:441px;
   font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);

  }
  .twofeatures .item-pro {
    padding: 0;
    width: 95%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin: 0px auto;
  }

  .twofeatures .item-pro dl {
    flex: 1;
    margin: 20px 15px;

  height:350px;
background:rgba(255,255,255,1);
border-radius:10px;
display: flex;
flex-direction: column;
  }

  .twofeatures .item-pro dt {
    width: 100%;
    display: -ms-flexbox;
   display: flex;
   flex-direction: column;
    text-align: center;
    -ms-flex-pack: center;
    justify-content: center;

  }
.twofeatures .item-pro dt .span1{
  
  margin-top: 28px;
 
 font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
/* line-height:27px; */
}
  .twofeatures .item-pro dt img {
    width: 60px;
    height: 70px;
    text-align: center;
    margin: 0px auto;
    margin-top: 45px;
  }

  .twofeatures .item-pro dt .span2 {
    width:60px;
    height:4px;
    background:rgba(42,177,243,1);
    margin: 20px auto;
    text-align: center;
  }

  .twofeatures .item-pro dt .span3 {
    width:245px;

    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    text-align: center;
     margin: 0px auto;
  }
  .process {
    width: 100%;
    background: #f9f9f9;
    padding: 50px 0
  }
</style>



// WEBPACK FOOTER //
// src/components/campuspaymen.vue